import { render, staticRenderFns } from "./PurchaseSelectContact.vue?vue&type=template&id=2564deaa&"
import script from "./PurchaseSelectContact.vue?vue&type=script&lang=js&"
export * from "./PurchaseSelectContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports